import styled from "styled-components";

export const LoginPageContainer = styled.div`
 
`
export const LoginPageTextBottom = styled.div`
  white-space: pre;
  padding-right: .25rem;
  color: rgba(0,0,0,.26);
`